import { APPSERVER_API_PREFIX } from '../axios/axios.constants';
import { useAxiosInstance } from '../reactQuery/ApiProvider.context';

export function useGraphQLFetcher<TData, TVariables>(document: string): (variables?: TVariables) => Promise<TData> {
  const axiosInstance = useAxiosInstance();

  return async (variables?: TVariables) => {
    const response = await axiosInstance.request<{ data: TData; errors?: { message: string }[] }>({
      method: 'post',
      url: `${APPSERVER_API_PREFIX}/graphql`,
      data: { query: document, variables },
    });

    if (response.data.errors?.length) {
      throw new Error(response.data.errors.map((e) => e.message).join('\n'));
    }

    return response.data.data;
  };
}
